import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import DeviceHealthSummary from "./DeviceHealthSummary";
import KeysSummary from "./KeysSummary";
import CertificatesSummary from "./CertificatesSummary";
import ScanSpecificReports from "./ScanSpecificReports";

const SUMMARY_CATEGORIES = {
  deviceHealthSummary: "Device Health Summary",
  keys: "Keys",
  certificates: "Certificates",
  scanSpecificReports: "Scan Specific Reports",
};
const OverallSummary: React.FC = () => {
  const [activeButton, setActiveButton] = useState<string>(
    SUMMARY_CATEGORIES.deviceHealthSummary
  );
  const navigate = useNavigate();

  const handleClick = (buttonName: string) => {
    setActiveButton(buttonName);
  };
  return (
    <div className="bg-white p-[10px]">
      <div className="flex justify-between items-center p-[10px]">
        <h1 className="font-bold text-2xl text-custom-bluenew">
          Overall Summary
        </h1>
        <button
          className="p-2 bg-custom-blue6 rounded-full"
          onClick={() => {
            navigate("/");
          }}
        >
          <X className="text-gray-50 xl:h-5 xl:w-5 lg:h-4 lg:w-4" />
        </button>
      </div>
      <div className="flex flex-row justify-start w-full pl-2">
        <div className="space-x-2">
          <button
            className={`px-6 py-2 rounded-t-md font-bold text-base
                      ${
                        activeButton === SUMMARY_CATEGORIES.deviceHealthSummary
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
            onClick={() => handleClick(SUMMARY_CATEGORIES.deviceHealthSummary)}
          >
            Device Health Summary
          </button>
          <button
            className={`px-6 py-2 rounded-t-md font-bold text-base
                      ${
                        activeButton === SUMMARY_CATEGORIES.keys
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
            onClick={() => handleClick(SUMMARY_CATEGORIES.keys)}
          >
            Keys
          </button>
          <button
            className={`px-6 py-2 rounded-t-md font-bold text-base
                      ${
                        activeButton === SUMMARY_CATEGORIES.certificates
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
            onClick={() => handleClick(SUMMARY_CATEGORIES.certificates)}
          >
            Certificates
          </button>
          <button
            className={`px-6 py-2 rounded-t-md font-bold text-base
                      ${
                        activeButton === SUMMARY_CATEGORIES.scanSpecificReports
                          ? "bg-custom-blue8 text-custom-blue6 "
                          : "bg-custom-blue7 text-white"
                      }
                      focus:outline-none
                    `}
            onClick={() => handleClick(SUMMARY_CATEGORIES.scanSpecificReports)}
          >
            Scan specific reports
          </button>
        </div>
      </div>
      <div className="h-auto">
        {activeButton === SUMMARY_CATEGORIES.deviceHealthSummary && (
          <DeviceHealthSummary />
        )}
        {activeButton === SUMMARY_CATEGORIES.keys && <KeysSummary />}
        {activeButton === SUMMARY_CATEGORIES.certificates && (
          <CertificatesSummary />
        )}
        {activeButton === SUMMARY_CATEGORIES.scanSpecificReports && (
          <ScanSpecificReports />
        )}
      </div>
      {/* Buttons */}
      {/* <div className="text-center space-x-20 py-4">
        <button className="bg-custom-blue9 px-6 py-3 text-white rounded-lg text-sm">
          Back
        </button>
        <button className="bg-custom-blue9 px-6 py-3 text-white rounded-lg text-sm">
          Home
        </button>
      </div> */}
    </div>
  );
};

export default OverallSummary;
